









































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { AuthModule } from '@/store/Auth/AuthModule';
import UpdateInstitutionFeaturesRequest from '@/models/Settings/Institutions/UpdateInstitutionFeaturesRequest';

@Component({ name: 'InstitutionFeaturesEdit' })
export default class extends SaascadaVueDialog {

    dialog = false;
    request: UpdateInstitutionFeaturesRequest = new UpdateInstitutionFeaturesRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateInstitutionFeaturesRequest();
        }
    }

    get featureToggles() {
        return AuthModule.me.institution.config.featureToggles;
    }

    async cancel() {
        this.dialog = false;
    }

    async save() {
        this.dialog = false;
    }

}
